import { SensitivityLevel } from '@ariksa/data-scanning';
import {
  DataClassifiers,
  DataExclusionsApiAddDataExclusionRequest,
  DataExclusionsApiDeleteDataExclusionRequest,
  DataExclusionsApiUpdateDataExclusionRequest,
  DataTypesApiAddDataTypeRequest,
  DataTypesApiDeleteDataTypeRequest,
  DataTypesApiUpdateDataTypeRequest,
} from '@ariksa/data-scanning/api';
import { QueryAction } from 'services/types';
import { QueryState } from 'services/utils/QueryState';

import { createSlice } from 'utils/@reduxjs/toolkit';

import { ContainerState } from './types';

// The initial state of the data configuration container
export const initialState: ContainerState = {
  dataClassifiers: QueryState.init([]),
  dataConfigurationAction: QueryState.init({}),
  sensitivityInfo: QueryState.init({}),
};

const dataClassificationSlice = createSlice({
  name: 'dataClassification',
  initialState,
  reducers: {
    getDataTypes(state, action: QueryAction<DataClassifiers[]>) {
      state.dataClassifiers = QueryState.next(state.dataClassifiers, action);
    },

    getDataExclusions(state, action: QueryAction<DataClassifiers[]>) {
      state.dataClassifiers = QueryState.next(state.dataClassifiers, action);
    },

    addDataType(
      state,
      action: QueryAction<any, DataTypesApiAddDataTypeRequest>,
    ) {
      state.dataConfigurationAction = QueryState.next(
        state.dataConfigurationAction,
        action,
      );
    },
    updateDataType(
      state,
      action: QueryAction<any, DataTypesApiUpdateDataTypeRequest>,
    ) {
      state.dataConfigurationAction = QueryState.next(
        state.dataConfigurationAction,
        action,
      );
    },
    deleteDataType(
      state,
      action: QueryAction<any, DataTypesApiDeleteDataTypeRequest>,
    ) {
      state.dataConfigurationAction = QueryState.next(
        state.dataConfigurationAction,
        action,
      );
    },

    addDataExclusion(
      state,
      action: QueryAction<any, DataExclusionsApiAddDataExclusionRequest>,
    ) {
      state.dataConfigurationAction = QueryState.next(
        state.dataConfigurationAction,
        action,
      );
    },
    updateDataExclusion(
      state,
      action: QueryAction<any, DataExclusionsApiUpdateDataExclusionRequest>,
    ) {
      state.dataConfigurationAction = QueryState.next(
        state.dataConfigurationAction,
        action,
      );
    },
    deleteDataExclusion(
      state,
      action: QueryAction<any, DataExclusionsApiDeleteDataExclusionRequest>,
    ) {
      state.dataConfigurationAction = QueryState.next(
        state.dataConfigurationAction,
        action,
      );
    },

    getSensitivityInfo(
      state,
      action: QueryAction<Record<string, SensitivityLevel>>,
    ) {
      state.sensitivityInfo = QueryState.next(state.sensitivityInfo, action);
    },
  },
});

export const { actions, reducer, name: sliceKey } = dataClassificationSlice;
